import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import CompanyView from '@/views/system/CompanyView.vue'
import UserList from '@/views/system/UserList.vue'
import DeliverySlipList from '@/views/system/DeliverySlipList.vue'
import DraftDeliverySlip from '@/views/system/DraftDeliverySlip.vue'
import NoticeList from '@/views/system/NoticeList.vue'
import EditNotice from '@/views/system/EditNotice.vue'

export const systemRoute: RouteRecordRaw = {
  path: '/system',
  component: BaseLayoutView,
  children: [
    { name: 'Company', path: 'company', component: CompanyView },
    { name: 'User', path: 'user/:companyKey', component: UserList },
    { name: 'DeliverySlipList', path: 'delivery-slip/:companyKey', component: DeliverySlipList },
    { name: 'AddDraftDeliverySlip', path: 'delivery-slip/:companyKey/new', component: DraftDeliverySlip },
    { name: 'EditDraftDeliverySlip', path: 'delivery-slip/:companyKey/:serialNo', component: DraftDeliverySlip },
    { name: 'NoticeList', path: 'notice', component: NoticeList },
    { name: 'AddNotice', path: 'notice/add', component: EditNotice },
    { name: 'EditNotice', path: 'notice/:noticeId', component: EditNotice }
  ]
}
